const PIXEL_ID = process.env.META_PIXEL_ID

const isBrowser = typeof window !== "undefined"

const isPixelReady = () => isBrowser && PIXEL_ID && typeof window.fbq === "function"

export const trackPageView = () => {
  if (!isPixelReady()) return
  window.fbq("track", "PageView")
}

export const trackEvent = (eventName, params = {}) => {
  if (!isPixelReady()) return
  window.fbq("track", eventName, params)
}

export const trackCustomEvent = (eventName, params = {}) => {
  if (!isPixelReady()) return
  window.fbq("trackCustom", eventName, params)
}

export const trackLead = (params = {}) => trackEvent("Lead", params)

export const trackContact = (params = {}) => trackEvent("Contact", params)

export const trackCompleteRegistration = (params = {}) =>
  trackEvent("CompleteRegistration", params)

const isPrimaryClick = (e) =>
  e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey

let linkClickTrackingInitialized = false

export const setupLinkClickTracking = () => {
  if (!isBrowser) return
  if (linkClickTrackingInitialized) return
  linkClickTrackingInitialized = true

  document.addEventListener("click", (e) => {
    if (!isPrimaryClick(e)) return

    const link = e.target.closest("a[href]")
    if (!link) return

    const href = link.getAttribute("href") || ""

    if (href.startsWith("mailto:")) {
      trackContact({ content_name: href.replace("mailto:", "") })
      return
    }

    if (href.startsWith("tel:")) {
      trackContact({ content_name: href.replace("tel:", "") })
    }
  })
}
